import { List, Paper } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import styled from "@emotion/styled";
import Placeholder from "components/Placeholder";
import AutomaticSystemItem from "./AutomaticSystemItem";
import Abilities from "services/permissions/abilities";

const AutomaticSystemsContainerLayout = styled(Paper)``;

function AutomaticSystemsContainer({
  automaticSystemsLoading,
  automaticSystems,
}) {
  // Vérifier si l'utilisateur a les permissions pour voir les systèmes automatiques
  const canViewAutomaticSystems = Abilities.ability.can(
    "read",
    "config_gates.automaticSystems"
  );

  if (!canViewAutomaticSystems) {
    return null; // Masquer complètement le composant si pas de permissions
  }

  if (automaticSystemsLoading) {
    return (
      <AutomaticSystemsContainerLayout>
        <Placeholder />
      </AutomaticSystemsContainerLayout>
    );
  }

  return (
    <AutomaticSystemsContainerLayout>
      <List>
        {automaticSystems?.map((system, index) => (
          <AutomaticSystemItem system={system} key={index} />
        ))}
      </List>
    </AutomaticSystemsContainerLayout>
  );
}

const mapStateToProps = (state) => ({
  automaticSystemsLoading: state.AutomaticSystems.automaticSystems.loading,
  automaticSystems: state.AutomaticSystems.automaticSystems.data,
});

export default connect(mapStateToProps)(AutomaticSystemsContainer);
